module.exports = __webpack_public_path__ + "img/oak_chevron_913m_detail_rsh2.97edb365.jpg";